export default __webpack_public_path__ + "static/media/user_icon.75ea3aa8.svg";